module.exports = __webpack_public_path__ + "static/flags/TI-107bb19ed97b0e8294d455497f713e04.gif";